import React from 'react';
import { Box } from '@mui/material';

const Layout = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'rgba(5, 8, 16, 0.95)',
        color: 'white',
        pt: '80px', // Espacio para el navbar fijo
      }}
    >
      {children}
    </Box>
  );
};

export default Layout; 